export const igLink = 'https://instagram.com/qbmedia.co'
export const fbLink = 'https://facebook.com/qbmedia.co'
export const LANDING_URL = 'https://dev.qbmedia.co.il'
/** 'whatsapp' | 'landing' — where plan subscribe buttons go (replaces iCount) */
export const PLAN_SUBSCRIBE_DESTINATION = 'whatsapp'
// il
export const ilWspLink = 'https://wa.me/972529921100'
export const ilNum = '972529921100'
// uae
export const uaeWspLink = 'https://wa.me/971581818006'
export const uaeNum = '971581818006'
export const $Rate = 1.8
export const AEDRate = 0.595

/** WhatsApp link with pre-filled message */
export const buildWspTextLink = (wspBase, text) => {
    const separator = wspBase.includes('?') ? '&' : '?'
    return `${wspBase}${separator}text=${encodeURIComponent(text)}`
}

/** Plan subscribe CTA — WhatsApp inquiry (replaces iCount checkout) */
export const buildPlanSubscribeLink = (
    wspBase,
    { buymsg, afterBuymsg, planName, title, periodLabel, priceLabel }
) => {
    const text = `${buymsg} ${planName} - ${title} (${periodLabel}, ${priceLabel})\n${afterBuymsg}`
    return buildWspTextLink(wspBase, text)
}

/** Optional landing-page link with plan context */
export const buildPlanLandingLink = (
    { planName, title, periodLabel, priceLabel }
) => {
    const params = new URLSearchParams({
        plan: `${planName} - ${title}`,
        billing: periodLabel,
        price: String(priceLabel),
    })
    return `${LANDING_URL}?${params.toString()}`
}
